/* More readable versions of queries for MediaQuery component */

const heights = {
  MIN_WIDTH_MOBILE: 320,
  MIN_WIDTH_TABLET: 600,
  MIN_WIDTH_LAPTOP: 801,
};

export default heights;
